import EventBus from '@/EventBus'

/**
 * This provides a wrapper over EventBus to listen to EventBus's events. It by itself registers the event and de-registers on unmount
 */
export default {
  data() {
    return {
      listeners: []
    }
  },
  methods: {
    listenToEventBus(name, handler) {
      EventBus.$on(name, handler)
      this.listeners.push({ name, handler })
    },
    eventBusEmit(name, payload) {
      EventBus.$emit(name, payload)
    }
  },
  beforeDestroy() {
    this.listeners.forEach(({ name, handler }) => {
      EventBus.$off(name, handler)
    })
  }
}
